import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2025 VisaBuddy. All rights reserved. | Your Trusted Immigration Partner</p>
      <p style={{ fontSize: '0.9rem', color: 'var(--gray)', marginTop: '0.5rem' }}>
        VisaBuddy: A Dedicated Visa & Embassy Services Vertical of Studien College<br />
        For Work Visas, Student Visas, Embassy Appointments & Residency Pathways
      </p>
    </footer>
  );
};

export default Footer;